<template>
  <button class="ml-2 py-2 px-3 rounded cursor-pointer text-base"
          :class="typeClass"
          :type="nativeType"
          :disabled="disabled"
          @click="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: "Button",
    props: {
      nativeType: {
        default: 'button'
      },
      type: {
        default: 'primary'
      },
      disabled: {
        default: null
      }
    },
    computed: {
      typeClass() {
        let str = 'text-gray-100 bg-blue-900 hover:bg-blue-700 hover:text-gray-300'
        if(this.type === 'secondary') {
          str = 'text-gray-100 bg-green-900 hover:bg-green-700 hover:text-gray-300'
        }
        if(this.disabled) {
          str += ' cursor-not-allowed opacity-50'
        }

        return str
      }
    }
  }
</script>
